// extracted by mini-css-extract-plugin
export default {"container":"sum_iuP0w"};